module.exports = __webpack_public_path__ + "static/img/flexiti.c8c528d9.jpg";